import { useEffect, useRef, useState } from "react";
import axios from "axios";

import { getSessionCompanies } from "utils";
import { useToast } from "./useToast";

import { useAuth } from "context/AuthContext";
import useSWR from "swr";

export const MXF_NEST_API_URL =
  process.env.REACT_APP_MXF_NEST_API || "https://api.mixfiscal.com.br/mxf/v1";

export const useMxfNestApi = () => {
  const onRejected = error => {
    return Promise.reject(error);
  };

  const apiRef = useRef(
    axios.create({
      baseURL: MXF_NEST_API_URL,
    }),
  );

  apiRef.current.interceptors.request.use(config => {
    config.headers.Authorization = `Bearer ${getSessionCompanies()}`;
    return config;
  });

  apiRef.current.interceptors.response.use(response => response, onRejected);

  return apiRef.current;
};

export const useFetchMxfNestApi = (url, axiosConfigs, config) => {
  const api = useMxfNestApi();
  const { tokenCompanies, revalidateAll, setRevalidateAll } = useAuth();

  const { data, error, mutate, revalidate, isValidating } = useSWR(
    url,
    async urlReturn => {
      const response = await api.get(urlReturn, axiosConfigs);
      return response.data;
    },
    config,
  );

  // Revalida todas as requisicoes para carregar os dados corretamente!
  useEffect(() => {
    if (revalidateAll?.length) {
      revalidate();
      setRevalidateAll();
    }
  }, [tokenCompanies, revalidate, revalidateAll, setRevalidateAll]);

  return {
    data,
    error,
    isError: !!error,
    isLoading: (!error && !data && String(data) !== "") || isValidating,
    isValidating,
    mutate,
    revalidate,
  };
};

export const useMxfNestToast = apiRef => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState({});
  const api = useMxfNestApi();
  const { addToast } = useToast();

  const onSend = async ({
    messageSuccess,
    messageFail,
    endpoint,
    type = "POST",
    data: dataFields = {},
    redirect = false,
    urlRedirect = "",
    fieldGetId = "",
    directId = "",
    isDisableMsg = false,
  }) => {
    try {
      setIsLoading(true);
      const { data } = await (apiRef ?? api)({
        method: type,
        url: endpoint,
        data: dataFields,
      });

      if (!isDisableMsg) {
        addToast({
          type: "success",
          title: "SUCESSO",
          description: messageSuccess,
        });
      }

      setData(data);
      setIsLoading(false);
      if (
        redirect &&
        urlRedirect !== "" &&
        fieldGetId !== "" &&
        data?.success
      ) {
        const field = data?.data[fieldGetId];
        window.location.href = `${urlRedirect}/${field}`;
      }
      if (directId !== "" && data?.success) {
        window.location.href = `${urlRedirect}/${directId}`;
      }
      return data;
    } catch (err) {
      setData(err);
      if (!isDisableMsg) {
        addToast({
          type: "error",
          title: "FALHA",
          description: messageFail,
        });
      }
      setIsLoading(false);
      throw err;
    }
  };

  return {
    isLoading,
    data,
    onSend,
  };
};
